import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const createCoverageSplitGeneration = {
  name: "createCoverageSplitGeneration" as const,
  input: z.object({
    parentSplitId: zExt.objectId(),
    selectedTreatmentId: zExt.objectId(),
  }),
  output: z.object({ newSplitId: zExt.objectId() }),
};
